import script from "./Guide.vue?vue&type=script&setup=true&lang=ts"
export * from "./Guide.vue?vue&type=script&setup=true&lang=ts"

import "./Guide.vue?vue&type=style&index=0&id=356484ea&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356484ea"]])

export default __exports__